export const validateForm = (
  data,
  fieldsToValidate,
  useFieldName = false,
  isRegistration = true
) => {
  const newErrors = {};

  fieldsToValidate?.forEach((field) => {
    // Required field validation
    if (!data[field]?.trim()) {
      if (useFieldName) {
        // Convert camelCase to space-separated words and capitalize first letter
        const fieldName = field
          .replace(/([A-Z])/g, " $1")
          .trim()
          .toLowerCase()
          .replace(/^./, (str) => str.toUpperCase());

        newErrors[field] = `${fieldName} is required`;
      } else {
        if (field === "chapter7" || field === "netWorth" || field === "linkedinUrl" || field === "websiteUrl" || field === "brokerTitle") {
          newErrors[field] = "";
        } else {
          newErrors[field] = "This field is required";
        }
      }
      return newErrors;
    }
    // Password validation - only for registration
    if (field === "password" && isRegistration) {
      const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!#@%$;^]).{8,}$/;
      if (!passwordRegex.test(data[field])) {
        newErrors[field] =
          "Password should be 8 or more in length with at least one number, special character(! # @ % $ ; ^) and uppercase letter.";
      }
    }
    // if (field === "password") {
    //   if (value.length < 8) {
    //     newErrors[field] = "Password must be at least 8 characters long";
    //   } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(value)) {
    //     newErrors[field] =
    //       "Password must contain at least one uppercase letter, one lowercase letter, and one number";
    //   }
    // }

    if (field === "mobile") {
      const phoneRegex = /^[0-9]{10}$/;
      newErrors[field] = phoneRegex.test(data[field])
        ? ""
        : "Please enter a valid 10-digit phone number";
    }
    // Field-specific validations
    switch (field) {
      case "firstName":
        const trimmedValue = data[field].trim();

        // Check if it starts or ends with space (but original value has spaces)
        if (data[field] !== trimmedValue) {
          newErrors.firstName = "First name cannot start or end with spaces";
        } else if (
          !/^[a-zA-Z0-9\-.'_]+(\s[a-zA-Z0-9\-.'_]+)*$/.test(trimmedValue)
        ) {
          newErrors.firstName = "Characters allowed: a-z A-Z 0-9 and - . ' _";
        } else if (trimmedValue.length > 40) {
          newErrors.firstName = "First name cannot exceed 40 characters.";
        }
        break;

      case "lastName":
        const trimmedLastName = data[field].trim();

        // Check if it starts or ends with space (but original value has spaces)
        if (data[field] !== trimmedLastName) {
          newErrors.lastName = "Last name cannot start or end with spaces";
        } else if (
          !/^[a-zA-Z0-9\-.'_]+(\s[a-zA-Z0-9\-.'_]+)*$/.test(trimmedLastName)
        ) {
          newErrors.lastName = "Characters allowed: a-z A-Z 0-9 and - . ' _";
        } else if (trimmedLastName.length > 40) {
          newErrors.lastName = "Last name cannot exceed 40 characters.";
        }
        break;

      case "email":
      case "emailId":
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data[field].trim())) {
          newErrors.email = "Invalid email address";
        }
        break;
      case "websiteUrl":
        const urlRegex = /^^((https?|ftp|smtp):\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$/;
        if (!urlRegex.test(data[field].trim())) {
          newErrors.websiteUrl = "Invalid website URL";
        }
        break;

      case "linkedinUrl":
        if (data[field]?.trim()) {
          const linkedinUrlRegex = /^^((https?|ftp|smtp):\/\/)?([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\/[^\s]*)?$/;
          if (data[field].trim().length > 2048) {
            newErrors.linkedinUrl = "LinkedIn URL cannot exceed 2048 characters";
          } else if (!linkedinUrlRegex.test(data[field].trim())) {
            newErrors.linkedinUrl = "Invalid website URL";
          }
        }
        break;

      case "phone":
      case "mobile":
      case "phoneNumber": {
        const rawNumber = data[field].replace(/^[0-9]{10}$/g, ""); // strip formatting
        const phoneRegex = /^[0-9]{10}$/;
        if (rawNumber.length > 1 && rawNumber.length !== 10) {
          // newErrors[field] = `${field} must be exactly 10 digits`;
          newErrors.phone = "Please enter a valid phone number";
          newErrors.mobile = "Please enter a valid mobile number";
          newErrors.phoneNumber = "Please enter a valid phone number";
        } else if (!phoneRegex.test(data[field])) {
          console.log("phoneRegex");
          newErrors[field] = "Please enter a valid phone number";
        }
        break;
      }

      case "password":
      case "confirmPassword":
      case "newPassword":
        if (isRegistration) {
          // Password strength validation only for registration
          const passwordRegex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!#@%$;^]).{8,}$/;

          if (data[field].length < 8) {
            newErrors[field] =
              "Password should be 8 or more in length with at least one number, special character(! # @ % $ ; ^) and uppercase letter.";
          } else if (!passwordRegex.test(data[field])) {
            newErrors[field] =
              "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character (! # @ % $ ; ^)";
          }
        } else {
          // For login, only check if password is empty
          if (!data[field]?.trim()) {
            newErrors[field] = "Password is required";
          }
        }
        break;

      case "zipCode":
        // US ZIP code validation
        if (!/^\d{5}(-\d{4})?$/.test(data[field].trim())) {
          newErrors.zipCode = "Invalid ZIP code format";
        }
        break;

      case "username":
        // Username validation (alphanumeric, 3-20 characters)
        if (!/^[a-zA-Z0-9]{3,20}$/.test(data[field])) {
          newErrors.username = "Username must be 3-20 alphanumeric characters";
        }
        break;

      case "url":
        // URL validation
        try {
          new URL(data[field]);
        } catch {
          newErrors.url = "Invalid URL format";
        }
        break;

      case "age":
        // Age validation (must be a number and within reasonable range)
        const age = parseInt(data[field]);
        if (isNaN(age) || age < 0 || age > 120) {
          newErrors.age = "Please enter a valid age";
        }
        break;

      case "dateOfBirth":
      case "dob":
        // if (new Date(data[field]) >= new Date()) {
        //   newErrors.dateOfBirth = "Date of birth must be in the past";
        //   newErrors.dob = "Date of birth must be in the past";
        // }
        const birthDate = new Date(data[field]);
        const today = new Date();

        if (birthDate >= today) {
          newErrors.dateOfBirth = "Date of birth must be in the past";
          newErrors.dob = "Date of birth must be in the past";
        } else {
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (
            monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < birthDate.getDate())
          ) {
            age--;
          }

          if (age < 18) {
            newErrors.dateOfBirth = "Please enter age above 18 years";
            newErrors.dob = "Please enter age above 18 years";
          }
        }
        break;

      case "ssn":
      case "ssnNo":
        if (!/^\d{4}$/.test(data[field])) {
          newErrors.ssn = "SSN must be 4 digits";
        }
        break;

      case "question":
        if (!/^[a-zA-Z0-9\-. '_]+$/.test(data[field])) {
          newErrors.question = "Characters allowed: a-z A-Z 0-9 and - . ' _";
        }
        break;

      case "propertyURL":
        const value = data[field];
        if (value.trim() !== "") {
          if (!/^[a-zA-Z0-9\-.#'_]+$/.test(value)) {
            newErrors.propertyURL = "Please remove invalid characters";
          }
        }
        break;

      case "companyName":
        if (!/^[a-zA-Z0-9\-.#'_]+$/.test(data[field])) {
          newErrors.companyName = "Characters allowed: a-z A-Z 0-9 and - . ' _";
        } else if (data[field].length > 70) {
          newErrors.companyName = "Company name cannot exceed 70 characters";
        }
        break;

      case "comments":
        if (data[field].length > 5000) {
          newErrors.comments = "Comments cannot exceed 5000 characters";
        }
        break;

      case "loanAmount":
        if (data[field].length > 10) {
          newErrors.comments = "Please Enter Valid Amount";
        }
        break;

      case "netWorth":
        if (data[field].length > 50) {
          newErrors.comments = "Please Enter Valid Amount";
        }
        break;

      case "chapter7":
        break;

      default:
        break;
    }
  });

  return newErrors;
};
